<template>
  <!--筛选器-->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="search-filter"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabel">筛选器</h4>
        </div>
        <div class="modal-body">
          <div class="input-group form-group">
            <span
              class="input-group-addon"
              id="basic-addon1"
              style="background-color: #eee"
              >{{
                searchType === "group"
                  ? "群名称"
                  : searchType === "folder"
                  ? "文件夹名"
                  : "文件名"
              }}</span
            >
            <input
              type="text"
              class="form-control"
              :placeholder="
                searchType === 'group'
                  ? '输入群名称，进行模糊搜索'
                  : searchType === 'folder'
                  ? '输入文件夹名，进行模糊搜索'
                  : '输入文件名，进行模糊搜索'
              "
              style="padding-left: 12px"
              v-model="query.searchName"
              v-on:keyup.enter="search"
            />
          </div>
          <div class="form-group" v-show="searchType === 'group'">
            <select class="form-control selectpicker" v-model="category">
              <option
                :value="cate.group_category_number"
                v-for="(cate, index) in groupCategories"
                :key="index"
              >
                {{ cate.group_category_name }}
              </option>
            </select>
          </div>
          <div
            class="form-group"
            v-show="searchType === 'file' || searchType === 'folder'"
          >
            <select
              class="form-control selectpicker"
              v-model="choose"
              @change="hideFirstLevelFolder"
            >
              <option value="1">我的云盘</option>
              <!-- <option value="3">我的备份盘</option> -->
              <option value="2">我的群组</option>
            </select>
          </div>
          <div
            class="form-group"
            v-show="
              choose == 2 && (searchType === 'file' || searchType === 'folder')
            "
          >
            <select
              class="form-control selectpicker"
              @change="hideFirstLevelFolder"
              v-model="selectedGroupNumber"
            >
              <option
                v-for="(group, index) in groups"
                :key="index"
                :value="group.group_number"
              >
                {{ group.group_name }}
              </option>
            </select>
          </div>
          <div
            class="form-group"
            v-show="
              choose == 2 &&
              (searchType === 'file' || searchType === 'folder') &&
              showFirstLevelFolder
            "
          >
            <p style="color: gray">
              {{ msg5021 }}
            </p>
            <select
              class="form-control selectpicker"
              v-model="query.first_level_folder"
            >
              <option
                v-for="(item, index) in firstLevelFolders"
                :key="index"
                :value="item.id"
              >
                {{ item.folder_name }}
              </option>
            </select>
          </div>
          <div
            class="form-group clearfix"
            v-show="searchType === 'file' || searchType === 'folder'"
          >
            <div class="datebox">
              <input
                @focus="getFormatDateFocus('setEndDate', $event)"
                class="form-control"
                placeholder="选择时间"
                type="text"
                v-model="query.search_start_date"
              />
            </div>
            <div class="datebox">--</div>
            <div class="datebox">
              <input
                @focus="getFormatDateFocus('setStartDate', $event)"
                class="form-control"
                placeholder="选择时间"
                type="text"
                v-model="query.search_end_date"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button class="btn btn-default" type="button" @click="clear">
            重置
          </button>
          <button class="btn btn-primary" type="button" @click="search">
            搜索
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGroups, getGroupCategorys } from "@/api/group/group";
import { getFormatDate } from "@/utils/index";
export default {
  name: "SearchFilter",
  props: {
    group_number: {
      type: String,
      default: "",
    },
    searchType: {
      type: String,
      default: "file",
    },
    firstLevelFolders: {
      type: Array,
    },
    showFirstLevelFolder: {
      type: Boolean,
    },
    msg5021: {
      type: String,
    },
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      groupCategories: [],
      category: null,
      selectedGroupNumber: "",
      query: {
        disk_type: "cloud",
        group_number: "",
        search_start_date: "",
        search_end_date: "",
        searchName: null,
        first_level_folder: "",
      },
      choose: 1,
      groups: [],
    };
  },
  created() {
    this.query.searchName = this.$route.query.search;
  },
  methods: {
    changeFirstLevelFolder(id) {
      this.query.first_level_folder = id;
    },
    hideFirstLevelFolder() {
      this.query.first_level_folder = "";
      this.$emit("hideFirstLevelFolder");
    },
    clear() {
      this.choose = 1;
      this.query.search_start_date = "";
      this.query.search_end_date = "";
      this.category = null;
    },
    search() {
      if (this.searchType === "file" || this.searchType === "folder") {
        if (this.choose == 1) {
          this.query.disk_type = "cloud";
          this.query.group_number = "";
        } else if (this.choose == 2) {
          this.query.disk_type = "cloud";
          this.query.group_number = this.selectedGroupNumber;
        } else if (this.choose == 3) {
          this.query.disk_type = "backup";
          this.query.group_number = "";
        } else {
          this.query.disk_type = "cloud";
          this.query.group_number = "";
        }
        this.$emit("searchByFilter", this.query);
      } else {
        this.$emit("searchByFilter", {
          category: this.category,
          searchName: this.query.searchName,
        });
      }
    },
    getGroups() {
      getGroups({
        group_review: "adopt",
      })
        .then((res) => {
          this.groups = res.entity.datas;
          this.selectedGroupNumber = this.groups[0].group_number;
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getGroupCategorys() {
      getGroupCategorys()
        .then((res) => {
          if (res.status_code === 200) {
            this.groupCategories = [
              {
                group_category_name: "请选择",
                group_category_number: null,
              },
            ].concat(res.entity);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getFormatDateFocus(setDate = "setEndDate", event) {
      let that = this;
      $(event.currentTarget)
        .datetimepicker({
          format: "yyyy-mm-dd",
          weekStart: 1,
          autoclose: true,
          startView: 2,
          minView: 2,
          pickerPosition: "top-right",
          language: "zh-CN",
        })
        .datetimepicker(
          setDate,
          setDate === "setEndDate" ? this.endDate : this.startDate
        )
        .datetimepicker("show")
        .on("changeDate", function (ev) {
          let day = getFormatDate(ev.date.valueOf());
          if (setDate === "setEndDate") {
            that.query.search_start_date = day;
            that.startDate = day;
          } else {
            that.query.search_end_date = day;
            that.endDate = day;
          }
        })
        .on("hide", function (ev) {
          $(ev.currentTarget).datetimepicker("remove");
        });
    },
  },
  mounted() {
    $("#search-filter").on("shown.bs.modal", () => {
      if (this.searchType === "file" || this.searchType === "folder") {
        this.getGroups();
      } else {
        this.getGroupCategorys();
      }
    });
  },
  destroyed() {
    $("#search-filter").off();
  },
};
</script>

<style scoped>
</style>